<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Add / Edit General Training Item
							</div>
							<div class="page_main">
								<div class="training-item-page">
									<div class="btn_el">
										<div class="tips">
											Please enter the description information for this training item.
										</div>
									</div>
									<el-form ref="formRef" :model="form" :rules="rules"
										label-position="top"
										class="training-form">
										<el-form-item label="Title" prop="title">
											<el-input v-model="form.title"
												placeholder=""
												clearable />
										</el-form-item>
										<el-form-item label="Description" prop="description">
											<el-input v-model="form.description"
												type="textarea"
												:rows="4"
												resize="none"
												placeholder="" />
										</el-form-item>
										<div class="btn-group">
				
											<el-button type="primary" @click="handleSave">
												Confirm
											</el-button>
				
											<el-button type="primary" @click="handleCancel">
												Cancel
											</el-button>
										</div>
									</el-form>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { trainGerenalAdd, trainGerenalEdit, trainGerenalDetail } from '@/api/trainManage/configTrain/generalTrain/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export
default {
	components:{
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			form: {
				title: "",
				description: "",
			},
			rules: {
				title: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				},
				],
				description: [{
					required: true,
					message: "Please enter",
					trigger: "blur",
				},
				],
			},
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.$route.query.oid) {
			//编辑
			trainGerenalDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					that.form.id = res.data.id;
					that.form.title = res.data.title;
					that.form.description = res.data.description;
				}
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
		}
	},
	watch: {
		//
	},
	methods: {
		handleSave() {
			let that = this;
			that.$refs.formRef.validate((valid) =>{
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				if(that.$route.query.oid) {
					// 编辑
					trainGerenalEdit(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}else {
					// 添加
					trainGerenalAdd(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-item-page {
  padding: 16px;
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
}

.page-tip {
  width: 100%;
  background: #f9f2e7;
  color: #333;
  border-radius: 4px;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 22px;
  box-sizing: border-box;
}

.training-form {
  width: 100%;
}

.training-form ::v-deep .el-form-item__label {
  padding-bottom: 8px;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}

.training-form ::v-deep .el-input__inner {
  height: 48px;
  line-height: 48px;
  border-radius: 8px;
  font-size: 16px;
}

.training-form ::v-deep .el-textarea__inner {
  border-radius: 8px;
  font-size: 16px;
  padding: 12px 15px;
  box-sizing: border-box;
}

.btn-group {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.btn-group .el-button {
  min-width: 88px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  padding: 0 24px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

